import { render, staticRenderFns } from "./attachmentUpload1.vue?vue&type=template&id=fb5b0c3e&scoped=true"
import script from "./attachmentUpload1.vue?vue&type=script&lang=js"
export * from "./attachmentUpload1.vue?vue&type=script&lang=js"
import style0 from "./attachmentUpload1.vue?vue&type=style&index=0&id=fb5b0c3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb5b0c3e",
  null
  
)

export default component.exports